(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5622],{

/***/ 25622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero053": function() { return /* binding */ Hero053; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var _Content053_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3320);
/* harmony import */ var _Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Hero053 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var address = (ref1 = payload === null || payload === void 0 ? void 0 : payload.address) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var email = (ref2 = payload === null || payload === void 0 ? void 0 : payload.email) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var phone = (ref3 = payload === null || payload === void 0 ? void 0 : payload.phone) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var addressTitle = (ref4 = payload === null || payload === void 0 ? void 0 : payload.addressTitle) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var emailTitle = (ref5 = payload === null || payload === void 0 ? void 0 : payload.emailTitle) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6;
    var phoneTitle = (ref6 = payload === null || payload === void 0 ? void 0 : payload.phoneTitle) !== null && ref6 !== void 0 ? ref6 : "";
    var contacts = [
        {
            id: "address",
            label: addressTitle,
            text: address,
            value: null,
            type: "text"
        },
        {
            id: "tel",
            label: phoneTitle,
            text: phone,
            value: "tel:".concat(phone),
            type: "link"
        },
        {
            id: "email",
            label: emailTitle,
            text: email,
            value: "mailto:".concat(email),
            type: "link"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, {
                    className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                    color: "dark",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().items),
                    children: contacts.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().item),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["icon-wrapper"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        name: item.id,
                                        className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon)
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().block),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                            color: "grey",
                                            className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().label),
                                            children: item.label
                                        }),
                                        item.type === "text" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                            className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                                            appearance: "bold",
                                            color: "dark",
                                            children: item.text
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: item.value,
                                            type: item.type,
                                            className: (_Content053_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link),
                                            children: item.text
                                        })
                                    ]
                                })
                            ]
                        }, item.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero053);


/***/ }),

/***/ 3320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content053_wrapper__aRfmL","title":"Content053_title__60cF8","items":"Content053_items__g7JS4","item":"Content053_item__UWVxf","block":"Content053_block__LGYUP","label":"Content053_label__aIZI7","link":"Content053_link__OJCj_","text":"Content053_text__7c5h5","icon-wrapper":"Content053_icon-wrapper__Wf64T"};

/***/ })

}]);